import { InstitucionSnp } from '@/shared/model/snp/instituciones-snp.model';
import { Component, Emit, Inject, Prop, Vue } from 'vue-property-decorator';
import InstitucionesSnpService from '@/shared/instituciones-snp/instituciones.snp.service';
import BuscadorInsttitucionSnp from '@/components/buscador-instituciones-snp/buscador-institucion-snp.vue';

@Component({
  components: {
    'buscador-institucion-snp': BuscadorInsttitucionSnp,
  },
})
export default class BuscadorInstitucionesSnpComponent extends Vue {
  @Inject('institucionesSnpService') private readonly institucionesSnpService: () => InstitucionesSnpService;

  @Prop({ required: false, default: false })
  public readonly mostrarInfo: boolean;

  @Prop({ required: false, default: false })
  public seleccionarSoloInstitucion: boolean;

  @Prop({ required: false, default: false })
  public ocultarSedes: boolean;

  public filtroReniecyt = '';
  public filtroNombreInstitucion = '';
  public instituciones: Array<InstitucionSnp> = [];
  public buscando = false;
  public noEncontrado = false;

  public totalRowsCards = 0;
  public currentPageCards = 1;
  public perPageCards = 15;

  public readonly pageOptions: Array<number> = [5, 15, 25, 50, 100, 150];

  public cambiarPagina(pagina) {
    this.currentPageCards = pagina;
    this.buscarInstitucion();
  }

  public buscarDesdePrimerPagina() {
    this.currentPageCards = 1;
    this.buscarInstitucion();
  }

  public buscarInstitucion(): void {
    this.noEncontrado = false;
    this.buscando = true;

    this.instituciones = [];
    this.emitirCambio();

    const reniecyt = this.filtroReniecyt.search('-') ? this.filtroReniecyt.split('-')[0] : this.filtroReniecyt;
    const reniecytSede = this.filtroReniecyt.search('-') ? this.filtroReniecyt : undefined;
    const paginationQuery = {
      page: this.currentPageCards - 1,
      size: this.perPageCards,
      sort: [],
      filter: {
        reniecyt: reniecyt,
        reniecytSede: reniecytSede,
        reniecytDependencia: reniecytSede,
        nombreInstitucion: this.filtroNombreInstitucion,
      },
    };

    this.institucionesSnpService()
      .retrieve(paginationQuery)
      .then(result => {
        this.instituciones = (result.data ?? []).map(institucion => InstitucionSnp.fromObject(institucion));
        this.totalRowsCards = Number(result.headers['x-total-count']);
      })
      .catch(() => {
        this.noEncontrado = true;
      })
      .finally(() => {
        this.buscando = false;
      });
  }

  @Emit('selected')
  public emitirSeleccion(institucion: InstitucionSnp): InstitucionSnp {
    this.instituciones = [];
    this.filtroReniecyt = '';
    this.filtroNombreInstitucion = '';

    return institucion;
  }

  @Emit('change')
  public emitirCambio(): number {
    return this.currentPageCards;
  }
}
